var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyFont7(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.877 8.83032C12.877 8.11676 12.877 7.75998 12.9933 7.47899C13.0703 7.29309 13.1831 7.12417 13.3254 6.98189C13.4677 6.83962 13.6366 6.72678 13.8225 6.64982C14.1035 6.53345 14.4603 6.53345 15.1738 6.53345H17.4707C18.9147 6.53345 19.6359 6.53345 20.0845 6.9821C20.5332 7.43076 20.5332 8.15198 20.5332 9.59595V11.8928C20.5332 12.6064 20.5332 12.9632 20.4168 13.2442C20.3399 13.4301 20.227 13.599 20.0848 13.7413C19.9425 13.8835 19.7736 13.9964 19.5877 14.0733C19.3067 14.1897 18.9499 14.1897 18.2363 14.1897",
    stroke: "#454545",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81445 11.1272H14.4082C15.2539 11.1272 15.9395 11.8128 15.9395 12.6584V17.2522C15.9395 18.0979 15.2539 18.7834 14.4082 18.7834H9.81445C8.96877 18.7834 8.2832 18.0979 8.2832 17.2522V12.6584C8.2832 11.8128 8.96877 11.1272 9.81445 11.1272Z",
    fill: "#454545",
    stroke: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyFont7);
export default __webpack_public_path__ + "static/media/copy_font7.754fbc62b1ce15e4d584626e6d3cb7a9.svg";
export { ForwardRef as ReactComponent };